export const IS_LOADING = 'IS_LOADING';
export const RESULT_BY = 'RESULT_BY';
export const SET_SECTOR = 'SET_SECTOR';
export const SET_RELOADED_TIME = 'SET_RELOADED_TIME';

// async function
export const SET_TABLE_DATA = 'SET_TABLE_DATA';



// WEBPACK FOOTER //
// ./src/dalalstreet/src/redux/HotStocks/ActionTypes.ts